export const datas = [
  {
    code: "AUD",
    currency_id: 29,
    emoji: "🇦🇺",
    name: "Australia",
    title: "Australian Dollar",
    rechargeMaxLimit: 5000,
  },
  {
    code: "CAD",
    currency_id: 9,
    emoji: "🇨🇦",
    name: "Canada",
    title: "Canadian Dollar",
    rechargeMaxLimit: 5000,
  },
  {
    code: "CHF",
    currency_id: 50,
    emoji: "🇨🇭",
    name: "Switzerland",
    title: "Switzerland Franc",
    rechargeMaxLimit: 5000,
  },
  {
    code: "EUR",
    currency_id: 6,
    emoji: "🇦🇹",
    name: "European Union",
    title: "European euro",
    rechargeMaxLimit: 2700,
  },
  {
    code: "GBP",
    currency_id: 7,
    emoji: "🇬🇧",
    name: "United Kingdom",
    title: "Pound",
    rechargeMaxLimit: 2250,
  },
  {
    code: "IDR",
    currency_id: 48,
    emoji: "🇮🇩",
    name: "Indonesia",
    symbol_left: "RP",
    title: "Indonesian Rupiah",
    rechargeMaxLimit: 50000000,
  },
  {
    code: "INR",
    currency_id: 101,
    emoji: "🇮🇳",
    name: "India",
    title: "Rupees",
    value: 1,
    rechargeMaxLimit: 500000,
  },
  {
    code: "JPY",
    currency_id: 57,
    emoji: "🇯🇵",
    name: "Japan",
    title: "Japanese yen",
    rechargeMaxLimit: 700000,
  },
  {
    code: "MYR",
    currency_id: 40,
    emoji: "🇲🇾",
    name: "Malaysia",
    symbol_left: "",
    title: "Malaysian Ringgit",
    rechargeMaxLimit: 20000,
  },
  {
    code: "NZD",
    currency_id: 56,
    emoji: "🇳🇿",
    name: "New Zealand",
    title: "New Zealand dollar",
    rechargeMaxLimit: 5000,
  },
  {
    code: "PHP",
    currency_id: 38,
    emoji: "🇵🇭",
    name: "Philippines",
    title: "Philippine Peso",
    rechargeMaxLimit: 200000,
  },
  {
    code: "PLN",
    currency_id: 51,
    emoji: "🇵🇱",
    name: "Poland",
    title: "Poland Zloty",
    rechargeMaxLimit: 20000,
  },
  {
    code: "SEK",
    currency_id: 53,
    emoji: "🇸🇪",
    name: "Sweden",
    title: "Sweden Krona",
    rechargeMaxLimit: 5000,
  },
  {
    code: "SGD",
    currency_id: 31,
    emoji: "🇸🇬",
    name: "Singapore",
    title: "Singapore Dollar",
    rechargeMaxLimit: 5000,
  },
  {
    code: "USD",
    currency_id: 5,
    emoji: "🇺🇸",
    name: "United States of America",
    title: "Dollar",
    rechargeMaxLimit: 5000,
  },
  {
    code: "HKD",
    currency_id: 62,
    emoji: "🇭🇰",
    name: "Hong kong",
    title: "Hong Kong dollar",
    rechargeMaxLimit: 5000,
  },
  {
    code: "THB",
    currency_id: 64,
    emoji: "🇹🇭",
    name: "Thailand",
    title: "Thai baht",
    rechargeMaxLimit: 200000,
  },
  {
    code: "DKK",
    currency_id: 65,
    emoji: "🇩🇰",
    name: "Denmark",
    title: "Danish krone",
    rechargeMaxLimit: 30000,
  },
  {
    code: "AED",
    currency_id: 27,
    emoji: "🇦🇪",
    name: "United Arab Emirates",
    title: "UAE dirham",
    rechargeMaxLimit: 20000,
  },
  {
    code: "SAR",
    currency_id: 32,
    emoji: "🇸🇦",
    name: "Kingdom of Saudi Arabia",
    title: "Saudi Arabia Riyal",
    rechargeMaxLimit: 20000,
  },
  {
    code: "ZAR",
    currency_id: 22,
    emoji: "🇿🇦",
    name: "South Africa",
    title: "South African Rand",
    rechargeMaxLimit: 50000,
  },
  {
    code: "VND",
    currency_id: 48,
    emoji: "🇻🇳",
    name: "Vietnam",
    title: "đồng",
    rechargeMaxLimit: 100000000,
  },
  {
    code: "EGP",
    currency_id: 46,
    emoji: "🇪🇬",
    name: "Egypt",
    title: "Egyptian Pound",
    rechargeMaxLimit: 45000,
  },
  {
    code: "TRY",
    currency_id: 30,
    emoji: "🇹🇷",
    name: "Turkey",
    title: "Turkey",
    rechargeMaxLimit: 30000,
  },
  // {
  //     "code": "YEN",
  //     "currency_id": 49,
  //     "emoji": "🇯🇵",
  //     "name": "Japan",
  //     "symbol_left": "",
  //     "title": "Japanese yens"
  // },
  // {
  //   code: "KHR",
  //   currency_id: 61,
  //   emoji: "🇰🇭",
  //   name: "Cambodian",
  //   title: "Cambodian rie",
  //   rechargeMaxLimit: 2000000,
  // },
  // {
  //   code: "MMK",
  //   currency_id: 63,
  //   emoji: "🇲🇲",
  //   name: "Myanmar",
  //   title: "Kyat",
  //   rechargeMaxLimit: 1000000,
  // },
  // {
  //     "code": "ZAR",
  //     "currency_id": 60,
  //     "emoji": "🇿🇦",
  //     "name": "South Africa",
  //     "symbol_left": "",
  //     "title": "South African Rand"
  // },
  // {
  //     "code": "AED",
  //     "currency_id": 11,
  //     "emoji": "🇦🇪",
  //     "name": "United Arab Emirates",
  //     "symbol_left": "فلس",
  //     "title": "UAE dirham"
  // },
  // {
  //     "code": "BGN",
  //     "currency_id": 8,
  //     "emoji": "🇧🇬",
  //     "name": "Bulgaria",
  //     "symbol_left": "$",
  //     "title": "Bulgaria Lev"
  // },
  // {
  //     "code": "BHD",
  //     "currency_id": 39,
  //     "emoji": "🇧🇭",
  //     "name": "Bahrain",
  //     "symbol_left": ".Ø¯.Ø¨",
  //     "title": "Bahraini dinar"
  // },
  // {
  //     "code": "CNY",
  //     "currency_id": 58,
  //     "emoji": "🇨🇳",
  //     "name": "China",
  //     "symbol_left": "Â¥",
  //     "title": "Chinese Yuan Renminbi"
  // },
  // {
  //     "code": "KES",
  //     "currency_id": 30,
  //     "emoji": "🇰🇪",
  //     "name": "Kenya",
  //     "symbol_left": "",
  //     "title": "Kenyan Shilling"
  // },
  // {
  //     "code": "KRW",
  //     "currency_id": 47,
  //     "emoji": "🇰🇷",
  //     "name": "South Korea",
  //     "symbol_left": "",
  //     "title": "South Korea"
  // },
  // {
  //     "code": "KWD",
  //     "currency_id": 32,
  //     "emoji": "🇰🇼",
  //     "name": "Kuwait",
  //     "symbol_left": "",
  //     "title": "Kuwaiti Dinar"
  // },
  // {
  //     "code": "KZT",
  //     "currency_id": 45,
  //     "emoji": "🇰🇿",
  //     "name": "Kazakhstan",
  //     "symbol_left": "",
  //     "title": "Kazakhstan Tenge"
  // },
  // {
  //     "code": "LKR",
  //     "currency_id": 54,
  //     "emoji": "🇱🇰",
  //     "name": "Sri Lanka",
  //     "symbol_left": "",
  //     "title": "Sri Lankan Rupee"
  // },
  // {
  //     "code": "MAD",
  //     "currency_id": 59,
  //     "emoji": "🇲🇦",
  //     "name": "Morocco",
  //     "symbol_left": "MAD",
  //     "title": "Moroccan Dirham"
  // },
  // {
  //   code: "MXN",
  //   currency_id: 46,
  //   emoji: "🇲🇽",
  //   name: "Mexico",
  //   title: "Mexican peso",
  //   rechargeMaxLimit: 10000,
  // },
  // {
  //   code: "NOK",
  //   currency_id: 52,
  //   emoji: "🇳🇴",
  //   name: "Norway",
  //   title: "Norwegian Krone",
  //   rechargeMaxLimit: 10000,
  // },
  // {
  //   code: "RUB",
  //   currency_id: 44,
  //   emoji: "🇷🇺",
  //   name: "Russia",
  //   title: "Russian Ruble",
  //   rechargeMaxLimit: 35000,
  // },
  // {
  //     "code": "SAR",
  //     "currency_id": 33,
  //     "emoji": "🇸🇦",
  //     "name": "Saudi Arabia",
  //     "symbol_left": "",
  //     "title": "Saudi Arabian Riyal"
  // },
  // {
  //   code: "HUF",
  //   currency_id: 66,
  //   emoji: "🇭🇺",
  //   name: "Hungary",
  //   title: "Forint",
  //   rechargeMaxLimit: 150000,
  // },
  {
    code: "ILS",
    currency_id: 67,
    emoji: "🇮🇱",
    name: "Israel",
    title: "Israel Shekel",
    rechargeMaxLimit: 5500,
  },
  // {
  //   code: "TWD",
  //   currency_id: 42,
  //   emoji: "🇹🇼",
  //   name: "Taiwan",
  //   title: "New Taiwan dollar",
  //   rechargeMaxLimit: 30000,
  // },
  // {
  //   code: "CZK",
  //   currency_id: 63,
  //   emoji: "🇨🇿",
  //   name: "Czech Republic",
  //   title: "Czech Koruna",
  //   rechargeMaxLimit: 20000,
  // },
  {
    code: "QAR",
    currency_id: 33,
    emoji: "🇶🇦",
    name: "Qatar",
    title: "Qatar Riyal",
    rechargeMaxLimit: 4000,
  },
  // {
  //   code: "OMR",
  //   currency_id: 44,
  //   emoji: "🇴🇲",
  //   name: "Oman",
  //   title: "Qatar Riyal",
  //   rechargeMaxLimit: 300,
  // },
  // {
  //   code: "KES",
  //   currency_id: 53,
  //   emoji: "🇰🇪",
  //   name: "Kenya",
  //   title: "Kenyan Shilling",
  //   rechargeMaxLimit: 60000,
  // },
  // {
  //   code: "NGN",
  //   currency_id: 41,
  //   emoji: "🇳🇬",
  //   name: "Nigeria",
  //   title: "Nigeria Naira",
  //   rechargeMaxLimit: 250000,
  // },
  // {
  //   code: "KWD",
  //   currency_id: 45,
  //   emoji: "🇰🇼",
  //   name: "Kuwait",
  //   title: "Kuwaiti Dinar",
  //   rechargeMaxLimit: 200,
  // },
  // {
  //   code: "BHD",
  //   currency_id: 35,
  //   emoji: "🇧🇭",
  //   name: "Bahrain",
  //   title: "Bahraini Dinar",
  //   rechargeMaxLimit: 400,
  // },
  // {
  //   code: "MAD",
  //   currency_id: 39,
  //   emoji: "🇲🇦",
  //   name: "Morocco",
  //   title: "Moroccan dirham",
  //   rechargeMaxLimit: 5000,
  // },
  // {
  //   code: "BND",
  //   currency_id: 62,
  //   emoji: "🇧🇳",
  //   name: "Brunei",
  //   title: "Brunei dollar",
  //   rechargeMaxLimit: 1000,
  // },
];
